module.exports = "5008981c89c55ecce50f38ab7b9ddec9.wav";


//////////////////
// WEBPACK FOOTER
// ./assets/sfx/firework_bass.wav
// module id = 94
// module chunks = 0